import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import Loading from '../../components/Loading/Loading';

import {
  fetchBlackList as fetchBlackListAction,
  deleteEntry as deleteEntryAction,
  showHideVariables as showHideVariablesAction,
  submitVariables as submitVariablesAction,
  changeVariable as changeVariableAction,
} from './BlackListActions';

import style from './BlackList.module.css';

class Companies extends Component {
  constructor(props) {
    super(props);

    this.delete = this.delete.bind(this);
    this.submitVariables = this.submitVariables.bind(this);
    this.changeVariable = this.changeVariable.bind(this);
  }

  componentDidMount() {
    this.props.fetchBlackList();
  }

  delete(id) {
    if (window.confirm('Are you sure you want to delete this entry?')) {
      this.props.deleteEntry(id);
      this.props.fetchBlackList();
    }
  }

  submitVariables() {
    const {
      submitVariables,
      timeAddedToBlockage,
      validAttemptInterval,
      authorizedAttempts,
    } = this.props;

    submitVariables({
      timeAddedToBlockage,
      validAttemptInterval,
      authorizedAttempts,
    });
  }

  changeVariable(e) {
    const { changeVariable } = this.props;
    const {
      id,
      value,
    } = e.target;

    changeVariable(id, value);
  }

  render() {
    const {
      blacklist,
      loading,
      variablesOpened,
      showHideVariables,
      timeAddedToBlockage,
      validAttemptInterval,
      authorizedAttempts,
    } = this.props;

    return (
      <div className="row">
        <div className="col-md-12 mt-4">
          { loading && <Loading /> }
          <h3><strong>Black list</strong></h3>
          <hr />
          <div className="row">
            <div className="col-md-12 mt-4">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <i className="fas fa-fw fa-gears" /> Blacklist variables
                  <i
                    className={`float-end fas fa-fw fa-arrow-circle-${variablesOpened ? 'up' : 'down'} ${style.arrow}`}
                    onClick={showHideVariables}
                  />
                </div>
                { variablesOpened && (
                  <div className={`panel-body ${style.variables}`}>
                    <div className="row">
                      <div className="mb-3 col-sm-6">
                        <label htmlFor="">Time increased each blockage:</label>
                        <br />
                        <small>(Every time the user is blocked, <strong>x</strong> minutes will be added to the total blockage time)</small>
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 col-md-5 col-lg-4">
                            <div className="input-group">
                              <input
                                type="number"
                                min="1"
                                className="form-control"
                                id="timeAddedToBlockage"
                                value={timeAddedToBlockage}
                                onChange={this.changeVariable}
                              />
                              <span className="input-group-addon">minutes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="mb-3 col-sm-6">
                        <label htmlFor="">Interval that will increment tries:</label>
                        <br />
                        <small>(After this interval the tries will be refreshed)</small>
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 col-md-5 col-lg-4">
                            <div className="input-group">
                              <input
                                type="number"
                                min="1"
                                className="form-control"
                                id="validAttemptInterval"
                                value={validAttemptInterval}
                                onChange={this.changeVariable}
                              />
                              <span className="input-group-addon">minutes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="mb-3 col-sm-6">
                        <label htmlFor="">Authorized attempts:</label>
                        <br />
                        <small>(How many times the user can try before being blocked)</small>
                        <div className="row">
                          <div className="col-xs-12 col-sm-6 col-md-5 col-lg-4">
                            <div className="input-group">
                              <input
                                type="number"
                                min="1"
                                className="form-control"
                                id="authorizedAttempts"
                                value={authorizedAttempts}
                                onChange={this.changeVariable}
                              />
                              <span className="input-group-addon">minutes</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.submitVariables}
                    >
                      <i className="fas fa-refresh fa-fw" /> Update
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <table className={`table table-striped table-condensed ${style.table}`}>
            <thead>
              <tr>
                <th>IP</th>
                <th>Attempts</th>
                <th>Last attempt</th>
                <th>Blocked time</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              { !blacklist.length && (
                <tr>
                  <td colSpan="10" className="text-center">No entries found.</td>
                </tr>
              )}
              { blacklist.map((entry) => {
                const blockedTime = moment(entry.blockedUntil).diff(moment(), 'minutes');
                let blockedUntil;

                if (blockedTime === 0) {
                  blockedUntil = `for ${moment(entry.blockedUntil).diff(moment(), 'seconds')} seconds`;
                } else {
                  blockedUntil = `for ${blockedTime} minutes`;
                }

                return (
                  <tr key={entry._id}>
                    <td>{entry.ip}</td>
                    <td>{entry.attempts}</td>
                    <td>{moment(entry.lastAttempt).fromNow()}</td>
                    <td>{blockedUntil}</td>
                    <td className="text-center">
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={this.delete.bind(this, entry._id)}
                      ><i className="fas fa-fw fa-times" /> Remove</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

Companies.propTypes = {
  loading: PropTypes.bool,
  variablesOpened: PropTypes.bool,
  variables: PropTypes.object,
  blacklist: PropTypes.array,
  fetchBlackList: PropTypes.func,
  deleteEntry: PropTypes.func,
  showHideVariables: PropTypes.func,
  submitVariables: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.blacklist.loading || state.blacklist.deleting || state.blacklist.updating,
  blacklist: state.blacklist.data,
  timeAddedToBlockage: state.blacklist.variables.timeAddedToBlockage,
  validAttemptInterval: state.blacklist.variables.validAttemptInterval,
  authorizedAttempts: state.blacklist.variables.authorizedAttempts,
  variablesOpened: state.blacklist.variablesOpened,
});

const mapDispatchToProps = {
  fetchBlackList: fetchBlackListAction,
  deleteEntry: deleteEntryAction,
  showHideVariables: showHideVariablesAction,
  submitVariables: submitVariablesAction,
  changeVariable: changeVariableAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Companies);
